import React, { createContext } from 'react'
import { App } from './App'

const AdminContext = createContext()

function Admin() {
  return (
    <AdminContext.Provider value={{ page: 'admin' }}>
      <App
        columns={[
          { name: 'unranked', displayName: 'Parked Issues', position: 'left' },
          { name: 'ranked', displayName: 'Active Issues', position: 'right' },
        ]}
        page="admin"
      />
    </AdminContext.Provider>
  )
}

export { Admin, AdminContext }
